function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 4a4 4 0 014-4h6a4 4 0 014 4v3h5v20a4 4 0 01-4 4H8a4 4 0 01-4-4V7h5V4zm3 3h8V4a1 1 0 00-1-1h-6a1 1 0 00-1 1v3z",
  fill: "url(#pick-up_svg__pick_up0_linear)",
  fillOpacity: 0.9
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#pick-up_svg__filter0_b)",
  fillOpacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  d: "M14 23h4v8h-4v-8z",
  fill: "url(#pick-up_svg__pick_up1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 11a2 2 0 011.6.8l6 8A2 2 0 0122 23H10a2 2 0 01-1.6-3.2l6-8A2 2 0 0116 11z",
  fill: "url(#pick-up_svg__pick_up2_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "pick-up_svg__pick_up0_linear",
  x1: 14.67,
  y1: 9.5,
  x2: 3.648,
  y2: 31.47,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7200"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC89C"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pick-up_svg__pick_up1_linear",
  x1: 16,
  y1: 11,
  x2: 16,
  y2: 31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD8B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "pick-up_svg__pick_up2_linear",
  x1: 16,
  y1: 11,
  x2: 16,
  y2: 31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD8B9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("filter", {
  id: "pick-up_svg__filter0_b",
  x: 0,
  y: 3,
  width: 32,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgPickUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,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";
export { SvgPickUp as ReactComponent };